import type { IGhCalloutCard, IGhIconName } from '../gpthelp-host-contract';
import type { TSupportTopic } from '../assistant/assistant-support';
import { clampText } from './card-text';
import type { ICardFormat } from './card-text';

export interface ISupportCardInput {
  id: string;
  topic: TSupportTopic;
  /** The request as the message carries it: the button builds the message from it again. */
  summary: string;
  /** The message the button opens: the card shows exactly it. */
  message: string;
  /** As the support link reads (`supportIconOf`). */
  icon: IGhIconName;
  /** The store and branch the message names: the button sends it only from them. */
  restaurantId: number;
  branchId: number;
  /** The language the message is written in: the button writes it in it again. */
  locale: string;
  /** The turn read customer-written text: marked like the proposal cards. */
  tainted: boolean;
}

/**
 * «Escríbale a nuestro equipo» (plan §8 R4): the message the user sends,
 * word for word, and the button that opens it. Nothing is sent until the
 * user sends it. After customer text it carries the «Basado en texto de un
 * cliente» badge of the proposal cards (shown instead of the icon).
 */
export function supportCard(
  input: ISupportCardInput,
  fmt: ICardFormat
): IGhCalloutCard {
  const card: IGhCalloutCard = {
    id: input.id,
    v: 1,
    type: 'callout',
    tone: 'info',
    icon: input.icon,
    title: clampText(fmt.t('assistant.support.title'), 160),
    text: clampText(input.message, 600),
    actions: [
      {
        // assistant-card-actions.ts opens the message.
        id: 'support',
        kind: 'host',
        label: clampText(fmt.t('assistant.support.button'), 40),
        icon: input.icon,
        style: 'success',
        payload: {
          topic: input.topic,
          summary: input.summary,
          restaurantId: input.restaurantId,
          branchId: input.branchId,
          locale: input.locale,
        },
      },
    ],
  };
  if (input.tainted)
    card.badge = {
      text: clampText(fmt.t('assistant.proposal.badge.tainted'), 40),
      tone: 'neutral',
    };
  return card;
}
